module.exports = __webpack_public_path__ + "img/Distractors_16.4f9b4996.png";